import React from 'react';
import PropTypes from 'prop-types';
import getColor from 'utils/getColor';

import { Container } from './styles';

const RowContainer = ({
  fullWidth,
  children,
  backgroundImg,
  backgroundColor,
  childRow,
  customBackgroundDesktop,
  customBackgroundMobile,
  displayMobile,
  displayDesktop,
  heightDesktop,
  heightMobile,
  innerContainerStyles,
  marginMobile,
  marginDesktop,
  paddingMobile,
  paddingDesktop,
  ...otherProps
}) => {
  const bgColor = getColor(backgroundColor);

  return (
    <Container
      bgColor={bgColor}
      bgImg={backgroundImg}
      childRow={childRow}
      className="row-container--container"
      customBackgroundDesktop={customBackgroundDesktop}
      customBackgroundMobile={customBackgroundMobile}
      displayMobile={displayMobile}
      displayDesktop={displayDesktop}
      heightDesktop={heightDesktop}
      heightMobile={heightMobile}
      gradientDirection={otherProps.gradientDirection}
      marginMobile={marginMobile}
      marginDesktop={marginDesktop}
      paddingMobile={paddingMobile}
      paddingDesktop={paddingDesktop}
      {...otherProps}
    >
      {children}
    </Container>
  );
};

RowContainer.propTypes = {
  backgroundImg: PropTypes.string, // background image
  backgroundColor: PropTypes.string,
  contentBelowSection: PropTypes.bool,
};

export default RowContainer;
